import {Component, AfterViewChecked, OnInit} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

declare function insertProgressBar(): void;
@Component({
  selector: 'ua-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewChecked {
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo({ top: 0, behavior: 'smooth' }); // you can also use 'auto'
      }
    });
  }

  ngAfterViewChecked(): void {
    insertProgressBar();
  }
}
